import React, { useState }  from 'react';
import { NavLink } from 'react-router-dom';

function HeaderNav (props) {
    const page = props.pageTitle;
    var homeActive = false;
    var aboutActive = false;
    var servActive = false;
    var contActive = false;

    if (page === "home" ) {
        homeActive = true;
    }
    else if (page === "about" ) {
        aboutActive = true;
    }
    else if (page === "services" ) {
        servActive = true;
    }
    else if (page === "contact" ) {
        contActive = true;
    }

    const [hamburgerOpen, setHamburgerOpen] = useState(true);

    const toggleHamburger = () =>{
        setHamburgerOpen(!hamburgerOpen);
        // console.log('hamburgerOpen = ', hamburgerOpen);
    };

    return (
        <div id="navWrapper">
            <div className={hamburgerOpen ? 'hamburger' : 'hamburger open'} onClick={toggleHamburger}>
              <div className="bar-one" />
              <div className="bar-two" />
              <div className="bar-three" />
            </div>
            <div className={hamburgerOpen ? 'hamburgerMenu' : 'hamburgerMenu open'}>
              <div className="hamMenu">
                <div className="hamMenuLinks">
                <ul>
                  <li><NavLink activeclassname="active" reloadDocument className={homeActive ? 'headerNavLink inactiveNav' : 'headerNavLink activeNav'} to="/home">Home</NavLink></li>
                  <li><NavLink activeclassname="active" reloadDocument className={aboutActive ? 'headerNavLink inactiveNav' : 'headerNavLink activeNav'} to="/about">About</NavLink></li>
                  <li><NavLink activeclassname="active" reloadDocument className={servActive ? 'headerNavLink inactiveNav' : 'headerNavLink activeNav'} to="/services">Services</NavLink></li>
                  <li><NavLink activeclassname="active" reloadDocument className={contActive ? 'headerNavLink inactiveNav' : 'headerNavLink activeNav'} to="/contact">Contact</NavLink></li>
                </ul>
                </div>
              </div>
            </div>
        </div> 
    );
}

export default HeaderNav;